import React, { useState, useEffect, useRef, useCallback } from 'react';
import Styles from './survey.module.scss';
import cn from 'classnames';
import KeyboardV2 from '@components/KeyboardV2';

const SurveyKeyboard = ({
  isFeedback, onClose, handleFeedback, selectedOption, options, feedback, handleOpenKeyboard, name, isKiosk, serverAppTheme
}) => {
  const [xDown, setXDown] = useState(null);
  const [yDown, setYDown] = useState(null);
  const [swipedDown, setSwipedDown] = useState(false);
  const [typed, setTyped] = useState('');

  const typedRef = useRef('');
  const handleFeedbackRef = useRef(handleFeedback);
  const selectedOptionRef = useRef(selectedOption);
  const optionsRef = useRef(options);

  useEffect(() => { handleFeedbackRef.current = handleFeedback; }, [handleFeedback]);
  useEffect(() => { selectedOptionRef.current = selectedOption; }, [selectedOption]);
  useEffect(() => { optionsRef.current = options; }, [options]);

  const getTouches = (evt) => {
    return evt.touches || evt.originalEvent.touches;
  };

  const handleTouchStart = (evt) => {
    const firstTouch = getTouches(evt)[0];
    setXDown(firstTouch.clientX);
    setYDown(firstTouch.clientY);
  };

  const handleTouchMove = (evt) => {
    evt.preventDefault();
    if (!xDown || !yDown) {
      return;
    }
    setXDown(null);
    setYDown(null);
  };

  const ref = useRef(null);

  const onClickBtn = useCallback((e) => {
    const currentTyped = typedRef.current;
    const typedValue = e === '{bksp}' ? currentTyped.slice(0, -1) : currentTyped.concat(e);
    typedRef.current = typedValue;
    setTyped(typedValue);
    handleFeedbackRef.current?.(typedValue);
    selectedOptionRef.current?.(optionsRef.current, typedValue);
  }, []);

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      onClose();
      setSwipedDown(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [ref]);

  const handleBlur = () => {
    const element = document.querySelectorAll('#feedbackTextArea');
    if (element) {
      element.forEach((e) => {
        e.blur();
      });
    }
  };

  const closeKeyboard = useCallback(() => {
    setSwipedDown(true);
  }, []);

  return (
    <>
      <textarea
        id="feedbackTextArea"
        name={name}
        type="textarea"
        label="Survey Feedback"
        // placeholder="Please write your feedback here....."
        placeholder="Click to enter your feedback here....."
        className={cn('fs_20 fw-500 h-100 p-4 w-100 ',Styles.textarea )}
        style={{borderRadius:'10px', background: serverAppTheme?.inputBg, color: serverAppTheme?.primary_text, '--placeholder-color': serverAppTheme?.input_placeholder}}
        rows="18"
        cols="50"
        value={typed}
        onClick={() => handleOpenKeyboard()}
        onFocus={() => { handleBlur(); }}
      />
      <div ref={ref}>
        {isFeedback ? (
          <div className={cn('d-flex flex-column justify-content-end align-items-end od-border-secondary', swipedDown ? 'col-4 p-0 offset-8' : '', isKiosk ? Styles.myTheme : Styles.myTheme1)} onTouchMove={(e) => handleTouchMove(e)} onTouchStart={(e) => handleTouchStart(e)} role="alert">
            {!swipedDown && (
                <KeyboardV2
                  onClickBtn={onClickBtn}
                  type="textDefaultCaps"
                  closeKeyboard={closeKeyboard}
                  btnSize="btn80 py-2"
                  customClass={` p-2`}
                  donebuttontheme={true}
                />
            )}
          </div>
        ) : <div className="d-none" />}
      </div>
    </>
  );
};

export default SurveyKeyboard;
